import React, { useState, useEffect } from 'react';
import { isEmpty } from 'lodash';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import SystemMasterTabel from '../../Components/SystemMasterTabel/SystemMasterTabel';
import * as action from './Store/SystemMasters.action';
import ConfirmationPopup from '../../Components/ModalPopup/ConfirmationPopup';
import { useComponent } from '../UserSetting/UsersLibrary/UserRights';

const tempObj = {
  name: null,
  isEmpty: false,
  isNew: true,
  isActive: true,
  hasLength: false,
  _id: '',
};

function OtherSampleMaster() {
  const dispatch = useDispatch();
  const reducer = useSelector((estate) => estate);
  const {
    SystemMastersDetails,
    UserDetails,
    Users: { logInRights },
  } = reducer;
  const { otherSamplesList } = SystemMastersDetails;
  const { userInfo } = UserDetails;

  const { t } = useTranslation('common');
  const loggedInUserId = userInfo.userId;

  const [isLoadingOS, setIsLoadingOS] = useState(false);
  const [showOS, setShowOS] = useState(false);
  const [isOtherSampleUnique, setIsOtherSampleUnique] = useState(true);
  const [buttonDownOs, setButtonDownOs] = useState(true);
  const [osBtnDisable, setOsBtnDisable] = useState(false);
  const [addingOS, setAddingOS] = useState(false);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [showConfirmationAD, setShowConfirmationAD] = useState(false);
  const [isLoadingConf, setIsLoadingConf] = useState(false);
  const [isOS, setIsOS] = useState(false);
  const [otherSamplesData, setOtherSamplesData] = useState([]);
  const [isUniqOsId, setIsUniqOsId] = useState([]);
  const [deleteId, setDeleteId] = useState('');
  const [activeInactiveID, setActiveInactiveID] = useState('');

  const { CheckActionPermission } = useComponent();
  const [userRights, setUserRights] = useState({});
  useEffect(() => {
    if (logInRights) {
      setUserRights(logInRights);
    }
  }, [logInRights]);
  const MasterAddEditAccess = CheckActionPermission(userRights, 'masters', 'samples', 'addEdit');

  useEffect(() => {
    setOtherSamplesData(otherSamplesList);
    if (addingOS) {
      setOtherSamplesData([
        ...otherSamplesList,
        {
          name: null,
          isEmpty: false,
          isNew: true,
          isActive: true,
          _id: '',
        },
      ]);
    }
  }, [otherSamplesList, addingOS]);

  const callApi = async () => {
    setButtonDownOs(!buttonDownOs);
    setIsLoadingOS(true);
    buttonDownOs ? setShowOS(true) : setShowOS(false);
    const osParams = {
      loggedInUserId,
    };
    isEmpty(otherSamplesData) && (await dispatch(action.getOtherSamplesDetails(osParams)));
    setIsLoadingOS(false);
  };

  const handleChanged = (event, i) => {
    const os = [...otherSamplesData];
    setIsOtherSampleUnique(true);
    setIsUniqOsId([]);
    os[i] = {
      ...os[i],
      name: event.target.value,
      isEmpty: event.target.value === '',
    };
    const arr = [];
    const arrIndex = [];
    os.forEach((ele, ind) => {
      os.forEach((objs, index) => {
        if (ele.name === objs.name && ind !== index) {
          arr.push(ele);
          arrIndex.push(index);
        }
      });
    });
    if (!isEmpty(arr)) {
      const arrs = [...arrIndex];
      const removeArss = Math.min(...arrs);
      const newArr = arrIndex.filter((ele) => ele !== removeArss);
      setIsUniqOsId([...newArr]);
    }
    setIsOtherSampleUnique(isEmpty(arr));
    let isDisableLength = false;
    os.forEach((lensElement) => {
      if (isEmpty(lensElement?.name?.trim())) {
        isDisableLength = true;
      }
    });
    setOsBtnDisable(isDisableLength);
    setOtherSamplesData(os);
  };

  const addOS = async () => {
    if (!showOS) {
      setAddingOS(true);
      setButtonDownOs(!buttonDownOs);
      setIsLoadingOS(true);
      buttonDownOs ? setShowOS(true) : setShowOS(false);
      const osParams = {
        loggedInUserId,
      };
      isEmpty(otherSamplesData) && (await dispatch(action.getOtherSamplesDetails(osParams)));
      setIsLoadingOS(false);
    } else if (!isEmpty(otherSamplesData)) {
      setOtherSamplesData([...otherSamplesData, tempObj]);
    } else {
      setOtherSamplesData([tempObj]);
    }
  };

  const handleDelete = (id) => {
    if (typeof id === 'number' || id === '') {
      otherSamplesData.splice(id, 1);
      otherSamplesData.forEach((otherSampelsElement) => {
        if (isEmpty(otherSampelsElement?.name?.trim()) && otherSampelsElement.isNew) {
          setOsBtnDisable(true);
        } else {
          setOsBtnDisable(false);
        }
      });
      setIsOtherSampleUnique(true);
      setIsUniqOsId([]);
      setOtherSamplesData([...otherSamplesData]);
    } else {
      setDeleteId(id);
      setShowConfirmation(true);
    }
  };

  const saveOS = async () => {
    setIsOS(true);
    if (!isEmpty(otherSamplesData)) {
      const emptyField = await otherSamplesData.filter((ositem) => ositem.name === null || ositem.name === '');

      if (isEmpty(emptyField)) {
        const data = otherSamplesData.map((osobj) => {
          return { ...osobj, name: osobj?.name?.trim() };
        });
        const otherSampleParams = {
          loggedInUserId,
          otherSamples: JSON.stringify(data),
          title: t('OTHER_SAMPLE_FILES.OTHER_FILE'),
        };
        setAddingOS(false);
        await dispatch(action.saveToSystemMaster(otherSampleParams, t));
        const osParams = {
          loggedInUserId,
        };
        await dispatch(action.getOtherSamplesDetails(osParams));
        // post API
      } else {
        const newState = otherSamplesData.map((otsobj) => (otsobj?.isEmpty === false && otsobj.name === null ? { ...otsobj, isEmpty: true } : otsobj));
        setOtherSamplesData(newState);
      }
    }
    setIsOS(false);
  };

  const activeInactiveClicked = (id) => {
    setShowConfirmationAD(true);
    setActiveInactiveID(id);
  };

  useEffect(() => {
    const array = [];
    otherSamplesData.forEach((ele, index) => {
      otherSamplesData.forEach((obj, places) => {
        if (index !== places && ele?.name === obj?.name) {
          array.push(ele);
        }
      });
    });
    if (isEmpty(array)) {
      setIsOtherSampleUnique(isEmpty(array));
      setIsUniqOsId([]);
    }
  }, [otherSamplesData]);

  const deleteConfirmed = async () => {
    setIsLoadingConf(true);
    const otherSampelsParams = {
      loggedInUserId,
      otherSampleId: deleteId,
      title: t('OTHER_SAMPLE_FILES.SAMPLE'),
    };
    await dispatch(action.deleteFromSystemMasters(otherSampelsParams, t));
    setIsLoadingConf(false);
    setShowConfirmation(false);
    setOtherSamplesData([...otherSamplesList]);
    const osParams = {
      loggedInUserId,
    };
    await dispatch(action.getOtherSamplesDetails(osParams));
  };

  const activeInactiveConfirmed = async () => {
    setIsLoadingConf(true);
    let os = {};
    otherSamplesData.forEach((ele) => {
      if (ele._id === activeInactiveID) {
        ele.isActive = !ele.isActive;
        const data = {
          ...ele,
          loggedInUserId,
          title: t('OTHER_SAMPLE_FILES.SAMPLE'),
        };
        os = data;
      }
    });
    await dispatch(action.setActiveInactive(os, t));
    setIsLoadingConf(false);
    setShowConfirmationAD(false);
    setOtherSamplesData([...otherSamplesData]);
  };

  return (
    <>
      <SystemMasterTabel
        isLoading={isLoadingOS}
        setShow={showOS}
        callApi={callApi}
        buttonDown={buttonDownOs}
        mainData={otherSamplesData}
        handleChanged={handleChanged}
        addBtnClicked={addOS}
        deletPressed={handleDelete}
        onSave={saveOS}
        isDesabled={isOS}
        title={t('OTHER_SAMPLE_FILES.OTHER_SAMPLES')}
        inputName="otherSamples"
        activeInactiveClicked={activeInactiveClicked}
        btnDisable={osBtnDisable}
        isUnique={isOtherSampleUnique}
        isUniqueId={isUniqOsId}
        masterAddEditAccess={MasterAddEditAccess}
      />
      {showConfirmation && (
        <ConfirmationPopup
          onOpen={showConfirmation}
          onConfirm={() => deleteConfirmed()}
          title={t('OTHER_SAMPLE_FILES.DELETE_FROM_SYSTEM_MASTER')}
          message={t('OTHER_SAMPLE_FILES.ARE_YOU_SURE_YOU_WANT_TO_DELETE_THIS_ITEM')}
          toggle={() => {
            setShowConfirmation(!showConfirmation);
          }}
          loading={isLoadingConf}
        />
      )}
      {showConfirmationAD && (
        <ConfirmationPopup
          onOpen={showConfirmationAD}
          onConfirm={() => activeInactiveConfirmed()}
          title={t('OTHER_SAMPLE_FILES.ACTIVATE_DEACTIVATE')}
          message={t('OTHER_SAMPLE_FILES.ARE_YOU_SURE_YOU_WANT_TO_ACTIVATE_DEACTIVATE_THIS_ITEM')}
          toggle={() => {
            setShowConfirmationAD(!showConfirmationAD);
          }}
          loading={isLoadingConf}
        />
      )}
    </>
  );
}

export default OtherSampleMaster;
